import React from 'react';
import authService from '../services/authService';

const AccessDenied = () => {
  const handleLogout = () => {
    authService.logout();
  };

  const userInfo = authService.getUserInfo();
  const userName = userInfo?.preferred_username || userInfo?.name || 'User';
  const userEmail = userInfo?.email || '';
  const userRoles = authService.getUserRoles();

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Authentication Bar */}
      <div style={{
        backgroundColor: '#2c3e50',
        color: 'white',
        padding: '8px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '14px'
      }}>
        <div>
          Welcome, <strong>{userName}</strong>
        </div>
        <button
          onClick={handleLogout}
          style={{
            backgroundColor: 'transparent',
            border: '1px solid white',
            color: 'white',
            padding: '4px 12px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
          }}
        >
          Logout
        </button>
      </div>

      {/* Access Denied Content */}
      <div style={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px 20px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '40px',
          maxWidth: '600px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          {/* Error Icon */}
          <div style={{
            fontSize: '64px',
            color: '#e74c3c',
            marginBottom: '20px'
          }}>
            🚫
          </div>

          {/* Title */}
          <h1 style={{
            color: '#2c3e50',
            fontSize: '28px',
            marginBottom: '16px',
            fontWeight: 'bold'
          }}>
            Access Denied
          </h1>

          {/* Message */}
          <p style={{
            color: '#666',
            fontSize: '16px',
            lineHeight: '1.6',
            marginBottom: '30px'
          }}>
            You do not have the required permissions to access the Hills Coupon Insights Dashboard. 
            This application requires <strong>Head Office</strong> or <strong>Administrator</strong> privileges.
          </p>

          {/* User Info */}
          <div style={{
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
            borderRadius: '6px',
            padding: '20px',
            marginBottom: '30px',
            textAlign: 'left'
          }}>
            <h3 style={{
              color: '#495057',
              fontSize: '16px',
              marginBottom: '12px',
              fontWeight: '600'
            }}>
              Account Information
            </h3>
            
            <div style={{ marginBottom: '8px' }}>
              <strong>Name:</strong> <span style={{ color: '#666' }}>{userName}</span>
            </div>
            
            {userEmail && (
              <div style={{ marginBottom: '8px' }}>
                <strong>Email:</strong> <span style={{ color: '#666' }}>{userEmail}</span>
              </div>
            )}
            
            <div style={{ marginBottom: '8px' }}>
              <strong>Current Roles:</strong> 
              <span style={{ color: '#666', marginLeft: '8px' }}>
                {userRoles.length > 0 ? userRoles.join(', ') : 'None assigned'}
              </span>
            </div>
            
            <div>
              <strong>Required Roles:</strong> 
              <span style={{ color: '#e74c3c', marginLeft: '8px' }}>
                headoffice, admin
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <button
              onClick={handleLogout}
              style={{
                backgroundColor: '#3498db',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#2980b9';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = '#3498db';
              }}
            >
              Switch Account
            </button>
            
            <button
              onClick={() => window.location.href = 'mailto:support@techsys.co.za?subject=Access%20Request%20-%20Hills%20Coupon%20Insights&body=Hello,%0A%0AI%20would%20like%20to%20request%20access%20to%20the%20Hills%20Coupon%20Insights%20Dashboard.%0A%0AAccount%20Details:%0AName:%20' + encodeURIComponent(userName) + '%0AEmail:%20' + encodeURIComponent(userEmail) + '%0ACurrent%20Roles:%20' + encodeURIComponent(userRoles.join(', ')) + '%0A%0APlease%20grant%20me%20the%20necessary%20permissions.%0A%0AThank%20you.'}
              style={{
                backgroundColor: '#27ae60',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#229954';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = '#27ae60';
              }}
            >
              Request Access
            </button>
          </div>

          {/* Footer */}
          <div style={{
            marginTop: '30px',
            padding: '20px 0',
            borderTop: '1px solid #e9ecef',
            color: '#6c757d',
            fontSize: '14px'
          }}>
            <p style={{ margin: 0 }}>
              For immediate assistance, please contact your system administrator or 
              <br />
              email <a href="mailto:support@techsys.co.za" style={{ color: '#3498db' }}>support@techsys.co.za</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied; 